import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { jdsSelectProps } from '../../../components/jds/selectProps';
import { CouponsAPI } from '../../../api/payments/coupons/api';

const SEARCH_DEBOUNCE_MS = 400;

export function CouponSelect({ value, onChange }) {
  const [searchText, setSearchText] = useState('');
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const requestId = useRef(0);

  // Mesma busca da listagem de cupons: debounce de 400ms e filtro por `code`
  // no servidor.
  useEffect(() => {
    const timeoutId = setTimeout(async () => {
      const currentRequest = ++requestId.current;
      setLoading(true);
      try {
        const response = await CouponsAPI.list({
          page: 0,
          limit: 20,
          code: searchText,
          active: true,
        });
        if (currentRequest === requestId.current) {
          setCoupons(response.data.content || []);
        }
      } catch (error) {
        if (currentRequest === requestId.current) {
          setCoupons([]);
          toast.error(error?.message || 'Erro ao buscar cupons.');
        }
      } finally {
        if (currentRequest === requestId.current) setLoading(false);
      }
    }, SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(timeoutId);
  }, [searchText]);

  return (
    <div className="form-group mb-0">
      <label>Selecione o cupom</label>
      <Select
        name="couponId"
        isSearchable
        isClearable
        isLoading={loading}
        placeholder="Buscar por código"
        noOptionsMessage={() => 'Nenhum cupom encontrado'}
        loadingMessage={() => 'Buscando cupons...'}
        options={coupons}
        // A busca é feita no servidor; evita filtrar de novo no cliente.
        filterOption={null}
        onInputChange={(text, { action }) => {
          if (action === 'input-change') setSearchText(text);
        }}
        getOptionLabel={(option) => option.code}
        getOptionValue={(option) => option.id}
        value={value}
        onChange={(option) => onChange(option || null)}
        {...jdsSelectProps}
      />
    </div>
  );
}
